( function( global, $ ) {
    "use strict";

    var _events = {
        onContactFilterChange: function (ev) {
            ev.preventDefault();

            var $checkbox = $(this),
                $formGroup = $checkbox.closest('.gr-form__field'),
                $radioType = $formGroup.find('input[type="radio"]').first(),
                $fieldset = $formGroup.closest('fieldset');

            $radioType.prop('checked', true);

            if ($checkbox.val() === 'all') {
                $checkbox.prop('checked', true);
                $fieldset.find('input[type="checkbox"]').each(function() {
                    var $this = $(this);

                    if ($this.get(0) !== $checkbox.get(0)) {
                        $this.prop('checked', false);
                    }
                });
            } else {
                $fieldset.find('input[type="checkbox"][value="all"]').prop('checked', false);

                var $formGroupInputs = $formGroup.find('input[type="checkbox"]');

                if ($formGroupInputs.filter(':checked').length === $formGroupInputs.length - 1) {
                    $formGroupInputs.prop('checked', false);

                    $formGroupInputs.find('input[type="checkbox"][value="all"]').prop('checked', true);
                }
            }
        },
        onClearTerm: function(ev) {
            ev.preventDefault();

            $('#' + $(this).data('search-clear')).val('').trigger('change');
        }
    };

    var $body = $('body');
    $body.on('app.ready', function(ev) {
        $body.on('change', 'fieldset[data-form-filters="contacts"] input[type="checkbox"]', _events.onContactFilterChange);
        $body.on('click', '[data-search-clear]', _events.onClearTerm);
    });

    

}( window.groots, jQuery ));
